import { type MutationHookOptions, useMutation } from "@apollo/client";
import { SetPlatformStripeBillingModeMutation } from "../graphql/mutations";
import type {
  SetPlatformStripeBillingModeMutationType,
  SetPlatformStripeBillingModeMutationVariablesType,
} from "@/types/graphql/admin.generated";

export function useSetPlatformStripeBillingModeMutation(
  options?: MutationHookOptions<
    SetPlatformStripeBillingModeMutationType,
    SetPlatformStripeBillingModeMutationVariablesType
  >
) {
  return useMutation<
    SetPlatformStripeBillingModeMutationType,
    SetPlatformStripeBillingModeMutationVariablesType
  >(SetPlatformStripeBillingModeMutation, options);
}
